import { render, staticRenderFns } from "./benefit.vue?vue&type=template&id=33926990&scoped=true&"
import script from "./benefit.vue?vue&type=script&lang=js&"
export * from "./benefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33926990",
  null
  
)

export default component.exports